import Vue from 'vue';
window.Vue = Vue;
import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

import VueApexCharts from 'vue-apexcharts';
Vue.component('apexchart', VueApexCharts);

Vue.component('public-market-analysis', require('./components/public/PublicMarketAnalysis.vue').default);

const app = new Vue({
    el: '#app',
});
